import { formatCurrency } from '../../../text';
import { DEFAULT_CURRENCY } from '../../../constants/price';

// DB/API values are integer cents; the UI displays and edits dollars.
export const formatMoney = (cents: number) =>
  formatCurrency(cents, DEFAULT_CURRENCY.name, DEFAULT_CURRENCY.scale_factor, {}, true);

export const centsToDollars = (cents: number) =>
  cents / DEFAULT_CURRENCY.scale_factor;

export const dollarsToCents = (dollars: number) =>
  Math.round(dollars * DEFAULT_CURRENCY.scale_factor);

// Mirrors backend `_memberPrice` for live recompute while editing; both rates
// come from the API response.
export const deriveMemberPrice = (
  priceExGst: number,
  discountPercent: number,
  gstPercent: number
) => {
  const saving = Math.round((priceExGst * discountPercent) / 100);
  const memberPriceExGst = priceExGst - saving;
  const memberPriceIncGst = Math.round(
    memberPriceExGst * (1 + gstPercent / 100)
  );
  return { saving, memberPriceExGst, memberPriceIncGst };
};
